import * as types from '../mutation-types'
import { API } from '../../api';
import { REPORT_DATA_MANAGER } from '../../data';
import { UTILS } from '../../utils';

export default {
    namespaced: true,
    state: {
        fromPage: '',
        gotAIConfig: false,
        aiConfigData: {},
        productList: {},
        productData: {},
        showReportPage: false,
        detailInfo: {},
        getReportTimes: 0,
        reportData: {},
        reportAIData: {},
        reportStrongData: {},
        reportMonthShowAll: false,
        reportMonthDataList: [],
        reportMonthDataTotalList: [],
        showVipBtn: false,
        showFreeCharacter: false, // 性格免费开关
        showNatureMainPop: false,
        hasAiCharacter: false,
        natureCharacterData: {},
        natureTalentData: {},
        natureGiftData: {},
        natureTimeLimit: 0,
        setReportAILeaveDone: false,
        reportActCountTime: 0,
        startReportActCount: false,  // 开始弹框倒计时
        reportActCountSecond: 0,  // 倒计时时间
        reportActCountTimeFunc: undefined, //倒计时函数
        reportActCountTime1: '00:00', // 倒计时时间展示
        reportActCountTime2: '0分0秒', // 倒计时时间展示
        reportActAIShowTime: 0,  //间隔多长时间更新一次
        showReportPage: false, //当前在不在测算页
        showReportActBtn: false, // 支付优惠按钮显示
        showReportActPopup: false,  //支付优惠弹框显示
        showReportActRemindPopup: false, //支付优惠弹框显示-支付页面
        curReportDetailInfo: {},  //当前弹框指定的八字信息
        curReportActPopupType: 1, //当前支付优惠弹框类型
        curReportActPopupData: null,  //支付优惠弹框数据
        nextReportActPopupData: null,  //支付优惠弹框数据
        nextNewUserPopupData: null,    //新用户648弹框
        reportActProductGiftData: {},  //支付优惠弹框支付商品数据-gift
        reportActProductDiffData: {},  //支付优惠弹框支付商品数据-diff
        reportActProductVipYearData: {},  //支付优惠弹框支付商品数据-vip_year
        reportActProductVipFullData: {},  //支付优惠弹框支付商品数据-vip_full
        showReportRepayPopup: false,    //重新生成弹框
        curReportRepayProductData: {},  //重新生成弹框商品数据
    },
    mutations: {
        [types.REPORT_UPDATE_REPORT_GIFT_DATA](state, params) {
            if(state.curReportActPopupData == null) {
                let reportData = REPORT_DATA_MANAGER.getReportPayDataByData(params.data);
                state.curReportActPopupData = reportData;
            }
            state.reportActCountSecond = state.curReportActPopupData.second;
            console.log('types.REPORT_UPDATE_REPORT_GIFT_DATA----', params, state.curReportActPopupData)
            // 白色弹框数据
            state.showReportActRemindPopup = params.from == 'leave' ? true : false;
            state.curReportActPopupType = state.curReportActPopupData.type;
            // 悬浮按钮数据
            state.showReportActBtn = params.from == 'suspend' ? true : false;
            // gift商品数据
            state.reportActProductGiftData = state.curReportActPopupData.pay.gift;
        },
        [types.REPORT_UPDATE_REPORT_DIFF_DATA](state, params) {
            if(state.curReportActPopupData == null) {
                let reportData = REPORT_DATA_MANAGER.getReportPayDataByData(params.data);
                state.curReportActPopupData = reportData;
            }
            state.reportActCountSecond = state.curReportActPopupData.second;
            console.log('types.REPORT_UPDATE_REPORT_DIFF_DATA----', params, state.curReportActPopupData)
            // 底部黄色弹框
            state.showReportActPopup = params.from == 'leave' ? true : false;
            state.curReportActPopupType = state.curReportActPopupData.type;
            // 悬浮按钮数据
            state.showReportActBtn = params.from == 'suspend' ? true : false;
            // diff商品数据
            state.reportActProductDiffData = state.curReportActPopupData.pay.diff;
        },
        [types.REPORT_UPDATE_REPORT_VIP_YEAR_FULL_DATA](state, params) {
            if(state.curReportActPopupData == null) {
                let reportData = REPORT_DATA_MANAGER.getReportPayDataByData(params.data);
                state.curReportActPopupData = reportData;
                state.reportActCountSecond = state.curReportActPopupData.second;
                console.log('types.REPORT_UPDATE_REPORT_VIP_YEAR_FULL_DATA----', params, state.curReportActPopupData)
                // 底部黄色弹框
                state.showReportActPopup = params.from == 'leave' ? false : true;
                state.curReportActPopupType = 3;
                // 悬浮按钮数据
                state.showReportActBtn = true;
                // vip_year、vip_full商品数据
                state.reportActProductVipYearData = state.curReportActPopupData.pay.vip_year;
                state.reportActProductVipFullData = state.curReportActPopupData.pay.vip_full;
            }else {
                if(state.nextReportActPopupData == null) {
                    let reportData = REPORT_DATA_MANAGER.getReportPayDataByData(params.data);
                    state.nextReportActPopupData = reportData;
                    state.reportActProductVipYearData = state.nextReportActPopupData.pay.vip_year;
                    state.reportActProductVipFullData = state.nextReportActPopupData.pay.vip_full;
                }
            }
        },
        [types.REPORT_UPDATE_REPORT_VIP_FULL_DATA](state, params) {
            if(state.curReportActPopupData == null) {
                let reportData = REPORT_DATA_MANAGER.getReportPayDataByData(params.data);
                state.curReportActPopupData = reportData;
                state.reportActCountSecond = state.curReportActPopupData.second;
                console.log('types.REPORT_UPDATE_REPORT_VIP_FULL_DATA----', params, state.curReportActPopupData)
                // 底部黄色弹框
                state.showReportActPopup = params.from == 'leave' ? false : true;
                state.curReportActPopupType = state.curReportActPopupData.type;
                // 悬浮按钮数据
                state.showReportActBtn = true;
                // vip_full商品数据
                state.reportActProductVipFullData = state.curReportActPopupData.pay.vip_full;
            }else {
                if(state.nextReportActPopupData == null) {
                    let reportData = REPORT_DATA_MANAGER.getReportPayDataByData(params.data);
                    state.nextReportActPopupData = reportData;
                    state.reportActProductVipFullData = state.nextReportActPopupData.pay.vip_full;
                }
            }
        },
    },
    actions: {
        // 获取测算配置信息
        initReportAIConfig({state}, params) {
            if(state.gotAIConfig) {
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
                return;
            }
            API.getAIConfig(params && params.params ? params.params : {}, function(data) {
                state.gotAIConfig = true;
                state.aiConfigData = data;
                var resultData = REPORT_DATA_MANAGER.getProductDataByData(data.product);
                state.productList = resultData.productList;
                state.productData = resultData.productData;
                console.log('获取测算配置信息成功:::::::', data, state.productList, state.productData)

                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            });
        },
        getReportDetailInfo({state}, params) {
            API.getDetailInfo({
                id: params.hid
            }, function(data){
                state.curReportDetailInfo = data;
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb(data);
                }
            }, () => {
                AppFate.$toast('八字信息没找到');
                state.showReportActBtn = false;
                state.showReportActPopup = false;
            });
        },
        // 根据id获取测评报告信息
        getReportInfo({state}, params) {
            state.detailInfo = params.detailInfo;
            console.log('getReportInfo------', params);
            API.getAIInfo({
                id: params.detailInfo.id
            }, function(data) {
                state.showReportPage = true;
                state.reportData = data;
                state.reportAIData = REPORT_DATA_MANAGER.getReportAIDataByData(data.ai);
                state.showFreeCharacter = data.free_character;
                state.showVipBtn = (state.reportData[state.productList[0]] == 0 ||state.reportData[state.productList[1]] == 0 || state.reportData[state.productList[2]] == 0 || state.reportData[state.productList[3]] == 0 || state.reportData[state.productList[4]] == 0) && (state.reportData[state.productList[5]] <= 0 && state.productData[state.productList[5]]) ? true : false;
                console.log('获取测评数据成功:::::::', data, state.reportData, state.productList, state.productData, state.showVipBtn);
                if(data.ai && data.ai.talent && data.ai.talent.needpay == 0) {
                    var talentData = REPORT_DATA_MANAGER.getTalentDataByData(data.ai.talent);
                    state.natureTalentData = Object.assign(talentData, data.ai.talent);
                    state.hasAiCharacter = data.ai.talent.des || (data.ai.talent.info && data.ai.talent.info.chart);
                }
                if(data.ai && data.ai.suggest_strong) {
                    state.reportStrongData = REPORT_DATA_MANAGER.getReportStrongDataByData(data.ai.suggest_strong);
                }
                if(data.ai && data.ai.month && data.ai.month.description_new) {
                    state.reportMonthDataList = [].concat(data.ai.month.description_new[0]);
                    state.reportMonthDataTotalList = [].concat(data.ai.month.description_new) 
                }
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb(data);
                }
            });
        },
        // 支付完成之后，根据id刷新测评报告信息
        updateReportInfo({state}, detailId) {
            function getReportInfo(id) {
                API.getAIInfo({
                    id: id
                }, function(data) {
                    console.log('更新测评数据成功:::::::', data, state.getReportTimes);
                    state.reportData = data;
                    state.reportAIData = REPORT_DATA_MANAGER.getReportAIDataByData(data.ai);
                    if(data.ai && data.ai.talent && data.ai.talent.needpay == 0) {
                        var talentData = REPORT_DATA_MANAGER.getTalentDataByData(data.ai.talent);
                        state.natureTalentData = Object.assign(talentData, data.ai.talent);
                        state.hasAiCharacter = data.ai.talent.des || (data.ai.talent.info && data.ai.talent.info.chart);
                    }
                    if(data.ai && data.ai.suggest_strong) {
                        state.reportStrongData = REPORT_DATA_MANAGER.getReportStrongDataByData(data.ai.suggest_strong);
                    }
                    if(data.ai && data.ai.month && data.ai.month.description_new) {
                        state.reportMonthDataList = [].concat(data.ai.month.description_new[0]);
                        state.reportMonthDataTotalList = [].concat(data.ai.month.description_new) 
                    }
                    state.getReportTimes++;
                    var times = 3;
                    if(state.getReportTimes < times) {
                        setTimeout(() => {
                            getReportInfo(detailId);
                        }, 1000);
                    }
                });
            }
            getReportInfo(detailId);
        },
        useReportFree({state}, params) {
            console.log('useReportFree------', params)
            API.useFree({
                id: params.id
            }, function(data) {
                console.log('更新测评数据成功:::::::', data.info, state.getReportTimes)
                state.aiConfigData.freeTimes = data.freeTimes;
                state.reportData = data.info;
                state.reportAIData = REPORT_DATA_MANAGER.getReportAIDataByData(data.info.ai);
                if(params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        freeUnlockReport({dispatch, state}, params) {
            API.freeUnlock({
                id: params.detailInfo.id,
                type: params.type ? params.type : 0,
            }, function(data) {
                console.log('免费解锁成功:::::::', data)
                state.showVipBtn = false;
                if(params.frompage == 'report') {
                    dispatch('updateReportInfo', params.detailInfo.id);
                }else if(params.frompage == 'nature') {
                    dispatch('getAiCharacter', {
                        detailInfo: params.detailInfo
                    });
                }
                if(params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            }, function(data) {
                console.error('免费解锁失败:::::::', data)
                if(params.failCb && typeof(params.failCb) == 'function') {
                    params.failCb();
                }
            })
        },
        getAiCharacter({state}, params) {
            API.getAiCharacter({
                id: params.detailInfo.id
            }, function(data) {
                console.log('获取天赋性格数据成功:::::::', data);
                var characterData = REPORT_DATA_MANAGER.getCharacterDataByData(data.character.info);
                state.natureCharacterData = Object.assign(characterData, data.character);
                var talentData = REPORT_DATA_MANAGER.getTalentDataByData(data.talent);
                state.natureTalentData = Object.assign(talentData, data.talent);
                state.hasAiCharacter = data.character.info && data.character.info.length > 0 || data.talent.des || (data.talent.info && data.talent.info.chart);
                state.natureGiftData = data.gift;
                state.natureTimeLimit = data.timelimit;
                // state.natureTimeLimit = 5;  //for test
                state.showVipBtn = state.natureCharacterData.needpay == 1 || state.natureTalentData.needpay == 1 ? true : false;

                var aiCharacter = AppFate.$store.state.reminder.aiCharacter;
                state.showNatureMainPop = !aiCharacter;
                // state.showNatureMainPop = true;
                if(params && params.cb && typeof(params.cb) == 'function') {
                    params.cb();
                }
            })
        },
        setAiCharacterData({state}, params) {
            var talentData = REPORT_DATA_MANAGER.getTalentDataByData(params);
            state.natureTalentData = Object.assign(talentData, params);
            state.hasAiCharacter = params.des || (params.info && params.info.chart);
        },
        setReportAILeave({state, dispatch}, params) {
            console.log('setReportAILeave-----', params);
            API.setLeave(params.params, function(data) {
                console.log('setLeave------', data);
                state.setReportAILeaveDone = true;
                if(data.length > 0) {
                    dispatch("updateReportActData", {
                        data: data,
                        type: 'leave'
                    });
                }
                if(data.length == 0) {
                    if(params && params.failCb && typeof(params.failCb) == 'function') {
                        params.failCb();
                    }
                }
            })
        },
        updateReportAddOtherShow({state, dispatch}, params) {
            console.log('updateReportAddOtherShow-----', params);
            API.addOtherShow(params.params, function(data) {
                console.log('addOtherShow上报成功-----', data)
                if(params.params && params.params.type == 1) {
                    // 处理数据
                    state.showFreeCharacter = data.free_character ? data.free_character : state.showFreeCharacter;
                    console.log('updateReportAddOtherShow-----', data, state.showFreeCharacter);
                    if(data.info && data.info.length > 0) {
                        dispatch("updateReportActData", {
                            data: data.info,
                            type: 'suspend'
                        });
                    }
                }
                if(params && params.sucCb && typeof(params.sucCb) == 'function') {
                    params.sucCb();
                }
            });
        },
        updateReportActData({state, dispatch, commit}, params) {
            // 处理新用户的648弹框
            let newArr = params.data.filter(el => el.type == 6);
            if(newArr.length > 0) {
                state.showReportActBtn = false;
                state.showReportActPopup = false;
                if(state.reportActCountTimeFunc) { 
                    clearTimeout(state.reportActCountTimeFunc);
                    state.reportActCountTimeFunc = null;
                };
                // 就直接先弹648
                dispatch('activity/initNewUserPopup', newArr[0], {root: true});
                return;
            }
            // 处理gift数据
            let giftArr = params.data.filter(el => el.type == 1);
            if(giftArr.length > 0) {
                commit(types.REPORT_UPDATE_REPORT_GIFT_DATA, {
                    data: giftArr[0],
                    from: params.type
                });
            }
            // 处理diff数据
            let diffArr = params.data.filter(el => el.type == 2);
            if(diffArr.length > 0) {
                commit(types.REPORT_UPDATE_REPORT_DIFF_DATA, {
                    data: diffArr[0],
                    from: params.type
                });
            }
            // 处理vip_year,vip_full数据
            let yearFullArr = params.data.filter(el => el.type == 3 || el.type == 4);
            if(yearFullArr.length > 0) {
                commit(types.REPORT_UPDATE_REPORT_VIP_YEAR_FULL_DATA, {
                    data: yearFullArr[0],
                    from: params.type
                });
            }
            // 处理vip_full数据
            let fullArr = params.data.filter(el => el.type == 5);
            if(fullArr.length > 0) {
                commit(types.REPORT_UPDATE_REPORT_VIP_FULL_DATA, {
                    data: fullArr[0],
                    from: params.type
                });
            }
            dispatch('runReportAICount');
        },
        updateReportMonthDataStatus({ state }) {
            state.reportMonthShowAll = !state.reportMonthShowAll;
            if(state.reportMonthShowAll) {
                state.reportMonthDataList = [].concat(state.reportMonthDataTotalList)
            }else {
                state.reportMonthDataList = [].concat(state.reportMonthDataTotalList[0])
            }
        },
        updateReportMonthDataListStatus({ state }, params) {
            let index = params.index;
            state.reportMonthShowAll = false;
            state.reportMonthDataList = [].concat(state.reportMonthDataTotalList[index]);
        },
        checkReportActData({state, dispatch}) {
            if(state.nextReportActPopupData) {
                console.log("展示下一个弹框", state.nextReportActPopupData);
                state.showReportActBtn = true;
                state.showReportActPopup = true;
                state.curReportActPopupData = Object.assign({}, state.nextReportActPopupData);
                state.reportActCountSecond = state.curReportActPopupData.second;
                state.curReportActPopupType = state.curReportActPopupData.type <= 4 ? 3 : state.curReportActPopupData.type;
                dispatch('runReportAICount');
                state.nextReportActPopupData = null;
            }
        },
        getReportAIShowTime({state, dispatch}, params) {
            API.getShowTime({}, function(data) {
                state.showFreeCharacter = data.free_character;
                console.log('getReportAIShowTime-----', data, state.showFreeCharacter);
                if(data.info && data.info.length > 0) {
                    dispatch("updateReportActData", {
                        data: data.info,
                        type: 'suspend'
                    });
                    // dispatch('runReportAICount');
                }
            })
        },
        updateReportShowTimeAndActData({state, dispatch}) {
            // 先清空数据
            state.showReportActBtn = false;
            state.showReportActPopup = false;
            state.showReportActRemindPopup = false;
            state.curReportActPopupData = null;
            state.nextReportActPopupData = null;
            // 再刷新数据
            API.getShowTime({}, function(data) {
                console.log('updateReportShowTimeAndActData-----', data);
                if(data.info && data.info.length > 0) {
                    dispatch("updateReportActData", {
                        data: data.info,
                        type: 'suspend'
                    });
                    dispatch('runReportAICount');
                }
            });
        },
        updateReportAIShowTime({state}, params){
            console.log('updateReportAIShowTime-11-------', params, state.curReportActPopupData);
            if(params.type != 6 && state.curReportActPopupData == null) {
                return;
            }
            let newParams = {
                type: state.curReportActPopupData ? state.curReportActPopupData.type : params.type, 
                second: params.second
            };
            newParams.type == params && params.type ? params.type : newParams.type;
            newParams = (newParams.type == 1 || newParams.type == 2) && state.curReportActPopupData ? Object.assign({
                hid: state.curReportActPopupData.hid,
            }, newParams) : newParams;
            console.log('updateReportAIShowTime-22-------', params, newParams);
            // return;
            API.upShowTime(newParams, function(data) {
                console.log('upShowTime success......')
            })
        },
        runReportAICount({state, dispatch}) {
            console.log('runReportAICount----', state.reportActCountSecond)
            // for test
            // state.reportActCountSecond = 10;
            // for test
            state.reportActAIShowTime = 0;
            if(state.reportActCountTimeFunc) { 
                clearTimeout(state.reportActCountTimeFunc)
            };
            if(state.reportActCountSecond == 0) { 
                state.showReportActBtn = false;
                state.showReportActPopup = true;
                state.showReportActRemindPopup = false;
                state.reportActCountTime1 = '00:00';
                state.reportActCountTime2 = '0分0秒';
                return;
            }
            function count() {
                state.reportActCountTime1 = UTILS.getTimeNumberStrBySecond(state.reportActCountSecond);
                state.reportActCountTime2 = UTILS.getTimeStrBySecond(state.reportActCountSecond);
                // console.error('count-----', state.reportActCountTime1, state.reportActCountTime2)
                // 每5秒提交一次更新
                if(state.reportActAIShowTime == 5) {
                    dispatch('updateReportAIShowTime', {second: state.reportActCountSecond});
                    state.reportActAIShowTime = 0;
                }
                if(state.reportActCountSecond == 0) {
                    dispatch('updateReportAIShowTime', {second: state.reportActCountSecond});
                    clearTimeout(state.reportActCountTimeFunc);
                    state.showReportActBtn = false;
                    state.showReportActPopup = true;
                    state.showReportActRemindPopup = false;
                    state.reportActCountTime1 = '00:00';
                    state.reportActCountTime2 = '0分0秒';
                }else {
                    state.reportActCountSecond--;
                    state.reportActAIShowTime++;
                    state.reportActCountTimeFunc = setTimeout(() => {
                        count();
                    }, 1000);
                }
            }
            count();
        },
        resetData({state}) {
            state.fromPage = '';
            state.gotAIConfig = false;
            state.aiConfigData = {};
            state.productList = {};
            state.productData = {};
            
            state.detailInfo = {};
            state.getReportTimes = 0;
            state.reportData = {};
            state.reportAIData = {};
            state.reportStrongData = {};
            state.reportMonthShowAll = false;
            state.reportMonthDataList = [];
            state.reportMonthDataTotalList = [];
            state.showReportActPopup = false;
            state.showReportActRemindPopup = false;
        },
        resetReportData({state}) {
            state.fromPage = '';
            state.setReportAILeaveDone = false;
            state.showReportPage = false;
            state.detailInfo = {};
            state.getReportTimes = 0;
            state.reportData = {};
            state.reportAIData = {};
            state.reportStrongData = {};
            state.reportMonthShowAll = false;
            state.reportMonthDataList = [];
            state.reportMonthDataTotalList = [];
            state.showVipBtn = false;
            state.showReportActPopup = false;
            state.showReportActRemindPopup = false;
        },
        resetNatureData({state}) {
            state.showNatureMainPop = false;
            state.hasAiCharacter = false;
            state.natureCharacterData = {};
            state.natureTalentData = {};
            state.natureGiftData = {};
            state.natureTimeLimit = 0;
            state.showVipBtn = false;
        }
    }
}
